import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "PDFDamageRelatedScreeningOnlineTypeBlockTestResults First" }
const _hoisted_2 = { class: "TestResultGridContainer" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "EmptyGridCell" }, null, -1)
const _hoisted_4 = { class: "KindOfSample" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = {
  key: 0,
  class: "Images"
}
const _hoisted_8 = {
  key: 1,
  class: "TextFeedback"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PDFRegion = _resolveComponent("PDFRegion")!
  const _component_PDFOnlineTypeSampleImage = _resolveComponent("PDFOnlineTypeSampleImage")!
  const _component_PDFOnlineTypeBlockWrap = _resolveComponent("PDFOnlineTypeBlockWrap")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chunkedAnalysesArray, (analysesChunk, aChunkIndex) => {
    return (_openBlock(), _createElementBlock(_Fragment, { key: aChunkIndex }, [
      (Array.isArray(analysesChunk))
        ? (_openBlock(), _createBlock(_component_PDFOnlineTypeBlockWrap, {
            key: 0,
            titles: _ctx.titles,
            encodedTitles: _ctx.encodedTitles,
            disableContinued: _ctx.disable.continued,
            disableToBeContinued: _ctx.disable.toBeContinued
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chunkedSamples, (sampleChunk, sChunkindex) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: sChunkindex }, [
                    (aChunkIndex === 0)
                      ? (_openBlock(), _createBlock(_component_PDFRegion, {
                          key: 0,
                          heading: _ctx.mixWB('TEST_RESULTS')
                        }, null, 8, ["heading"]))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.oType.getTestResultsTexts(), (textItem) => {
                      return (_openBlock(), _createElementBlock("p", {
                        key: textItem.text
                      }, _toDisplayString(textItem.text), 1))
                    }), 128)),
                    _createElementVNode("div", _hoisted_2, [
                      _createElementVNode("div", {
                        class: "TestResultGrid",
                        style: _normalizeStyle({ gridTemplateColumns: `repeat(${sampleChunk.length + 1}, 175px)` })
                      }, [
                        _hoisted_3,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sampleChunk, (sample, sIndex) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: sample.hashID + sIndex,
                            class: _normalizeClass(["SampleTitle", _ctx.results[sIndex].overallResultClass])
                          }, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.getFullSampleTitle(sample)), 1),
                            _createElementVNode("span", _hoisted_4, _toDisplayString(sample.getKindOfSampleText()), 1)
                          ], 2))
                        }), 128)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(analysesChunk, (analysisTest, rIndex) => {
                          return (_openBlock(), _createElementBlock(_Fragment, {
                            key: analysisTest.id
                          }, [
                            _createElementVNode("div", {
                              class: _normalizeClass(rIndex % 2 ? 'Even' : 'Odd')
                            }, _toDisplayString(_ctx.mixWB(analysisTest.translation)), 3),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sampleChunk, (sample, sIndex) => {
                              return (_openBlock(), _createElementBlock(_Fragment, {
                                key: sample.hashID + sIndex
                              }, [
                                (!['existing', 'postponed'].includes(sample.sampleType))
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 0,
                                      class: _normalizeClass([
                          _ctx.results[sIndex][analysisTest.id].class,
                          {
                            'Even': !_ctx.results[sIndex][analysisTest.id].result && rIndex % 2,
                            'Odd': !_ctx.results[sIndex][analysisTest.id].result && !(rIndex % 2),
                          }])
                                    }, _toDisplayString(_ctx.results[sIndex][analysisTest.id].text), 3))
                                  : (rIndex === 0)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        (sample.sampleType === 'postponed')
                                          ? (_openBlock(), _createElementBlock("div", {
                                              key: 0,
                                              class: "TextFeedback",
                                              style: _normalizeStyle({
                          gridRow: `2 / ${analysesChunk.length + 2}`,
                          gridColumn: sIndex + 2
                        })
                                            }, [
                                              _createElementVNode("p", null, _toDisplayString(_ctx.mixWB('SAMPLE_POSTPONED')), 1)
                                            ], 4))
                                          : (sample.sampleType === 'existing')
                                            ? (_openBlock(), _createElementBlock("div", {
                                                key: 1,
                                                class: "TextFeedback",
                                                style: _normalizeStyle({
                          gridRow: `2 / ${analysesChunk.length + 2}`,
                          gridColumn: sIndex + 2
                        })
                                              }, [
                                                _createElementVNode("p", null, _toDisplayString(_ctx.mixWB('EXISTING_SAMPLE_FROM_EXTERNAL_PROJECT')), 1),
                                                _createElementVNode("p", null, [
                                                  _createElementVNode("strong", null, _toDisplayString(_ctx.mixWB('RESULT')), 1),
                                                  _hoisted_5,
                                                  _createElementVNode("span", null, _toDisplayString(_ctx.results[sIndex].label), 1)
                                                ]),
                                                _createElementVNode("p", null, [
                                                  _createElementVNode("strong", null, _toDisplayString(_ctx.mixWB('REFERENCE')), 1),
                                                  _hoisted_6,
                                                  _createElementVNode("span", null, _toDisplayString(_ctx.results[sIndex].notes?.explanation), 1)
                                                ])
                                              ], 4))
                                            : _createCommentVNode("", true)
                                      ], 64))
                                    : _createCommentVNode("", true)
                              ], 64))
                            }), 128))
                          ], 64))
                        }), 128))
                      ], 4),
                      (sampleChunk.length === 1 && _ctx.getImages(sampleChunk[0]).length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            _createElementVNode("p", null, _toDisplayString(_ctx.mixWB('IMAGES_OF_X', [sampleChunk[0].getReferenceSample().sampleTypeID])), 1),
                            _createVNode(_component_PDFOnlineTypeSampleImage, {
                              sample: sampleChunk[0],
                              context: _ctx.context
                            }, null, 8, ["sample", "context"])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ], 64))
                }), 128))
              ])
            ]),
            _: 2
          }, 1032, ["titles", "encodedTitles", "disableContinued", "disableToBeContinued"]))
        : (!Array.isArray(analysesChunk))
          ? (_openBlock(), _createBlock(_component_PDFOnlineTypeBlockWrap, {
              key: 1,
              titles: _ctx.titles,
              encodedTitles: _ctx.encodedTitles,
              disableContinued: _ctx.disable.continued,
              disableToBeContinued: _ctx.disable.toBeContinued
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: _normalizeClass(["PDFDamageRelatedScreeningOnlineTypeBlockTestResults", {Last: aChunkIndex + 1 >= _ctx.chunkedAnalysesArray.length}])
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chunkedSamples, (sampleChunk, sChunkindex) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: sChunkindex,
                      class: "TestResultGridContainer"
                    }, [
                      _createElementVNode("div", {
                        class: "TestResultGrid",
                        style: _normalizeStyle({ gridTemplateColumns: `repeat(${sampleChunk.length + 1}, 175px)` })
                      }, [
                        _createElementVNode("div", {
                          class: _normalizeClass(aChunkIndex % 2 ? 'Even' : 'Odd')
                        }, _toDisplayString(_ctx.mixWB(analysesChunk.translation)), 3),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sampleChunk, (sample, sIndex) => {
                          return (_openBlock(), _createElementBlock(_Fragment, {
                            key: sample.hashID + sIndex
                          }, [
                            (!['existing', 'postponed'].includes(sample.sampleType))
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  class: _normalizeClass([
                        _ctx.results[sIndex][analysesChunk.id].class,
                        {
                          'Even': !_ctx.results[sIndex][analysesChunk.id].result && aChunkIndex % 2,
                          'Odd': !_ctx.results[sIndex][analysesChunk.id].result && !(aChunkIndex % 2),
                        }])
                                }, _toDisplayString(_ctx.results[sIndex][analysesChunk.id].text), 3))
                              : (_openBlock(), _createElementBlock("div", _hoisted_8))
                          ], 64))
                        }), 128))
                      ], 4)
                    ]))
                  }), 128))
                ], 2)
              ]),
              _: 2
            }, 1032, ["titles", "encodedTitles", "disableContinued", "disableToBeContinued"]))
          : _createCommentVNode("", true)
    ], 64))
  }), 128))
}